module.exports = __webpack_public_path__ + "static/media/SM_ComponentExample_2@2x.bd895a25.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/sportsmate/SM_ComponentExample_2@2x.jpg
// module id = 172
// module chunks = 0